import { CoObjectItem } from "../interfaces/CoObject";
import React, { useEffect } from "react";
import { DocPropKeys, retrieveDocumentProp } from "../../utils/helpers/CustomXmlHelper";
import LoadingManager from "../../common/loading/LoadingManager";
import { RETRIEVE_DOCUMENT_ID_NOTIFICATION } from "../../utils/constants/notification";

export interface CoRetrieveDocumentIdStateProps {
  children: (coObject: CoObjectItem) => React.JSX.Element;
}

interface CoRetrieveDocumentIdState {
  loading?: boolean;
  failed: boolean;
  coObject?: CoObjectItem;
  documentId?: string;
}

const coRetrieveDocumentIdInitialState = {
  failed: false,
};

export const CoRetrieveDocumentId = (props: CoRetrieveDocumentIdStateProps) => {
  const [state, setState] = React.useState<CoRetrieveDocumentIdState>(coRetrieveDocumentIdInitialState);
  const { coObject } = state;

  useEffect(() => {
    LoadingManager.create(RETRIEVE_DOCUMENT_ID_NOTIFICATION);
    retrieveDocumentProp(DocPropKeys.DocumentId)
      .then((documentId) => {
        setState({
          ...state,
          documentId: documentId,
          coObject: { documentId: documentId } as CoObjectItem,
          loading: false,
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-undef
        console.error(error);
        setState({ ...state, loading: false, failed: true });
      })
      .finally(() => {
        LoadingManager.remove(RETRIEVE_DOCUMENT_ID_NOTIFICATION);
      });
  }, []);

  if (coObject) return props.children(coObject);
  //TODO handle failure verbose
  return null;
};
